import yearsHelper from '../../helpers/yearsHelper';

interface IYearSelectProps {
  yearFrom: number;
  yearTo: number;
  setYearFrom(year: number): void;
  setYearTo(year: number): void;
  onDone?(): void;
}

const YearSelect = ({ yearFrom, yearTo, setYearFrom, setYearTo, onDone }: IYearSelectProps) => {
  return (
    <div className="flex h-full flex-col">
      <div className="flex-1 min-h-0 flex mb-5">
        <div className="w-1/2 px-4 h-full flex flex-col">
          <label className="block text-center mb-4 font-bold">از سال</label>

          <div className="flex-1 min-h-0 ltr overflow-y-auto overflow-x-hidden">
            <ul className="text-center">
              {yearsHelper().map((year) => {
                return !yearTo || (yearTo && year.persian <= yearTo) ? (
                  <li
                    className={`h-10 cursor-pointer hover:bg-primary hover:text-white flex justify-center items-center bg-neutral-100 rounded-lg mb-1 ${
                      yearFrom && year.persian === yearFrom ? 'bg-primary text-white' : ''
                    }`}
                    key={year.persian}
                    onClick={() => setYearFrom(year.persian)}
                  >
                    {`${year.persian} - ${year.global}`}
                  </li>
                ) : null;
              })}
            </ul>
          </div>
        </div>
        <div className="w-1/2 px-4 h-full flex flex-col">
          <label className="block text-center mb-4 font-bold">تا سال</label>

          <div className="flex-1 min-h-0 ltr overflow-y-auto overflow-x-hidden">
            <ul className="text-center">
              {yearsHelper().map((year) => {
                return !yearFrom || (yearFrom && year.persian >= yearFrom) ? (
                  <li
                    className={`h-10 cursor-pointer hover:bg-primary hover:text-white flex justify-center items-center bg-neutral-100 rounded-lg mb-1 ${
                      yearFrom && year.persian === yearTo ? 'bg-primary text-white' : ''
                    }`}
                    key={year.persian}
                    onClick={() => setYearTo(year.persian)}
                  >
                    {`${year.persian} - ${year.global}`}
                  </li>
                ) : null;
              })}
            </ul>
          </div>
        </div>
      </div>

      <button onClick={onDone || undefined} className="button secondary" type="button">
        ادامه مراحل
      </button>
    </div>
  );
};

export default YearSelect;
